import { NgModule } from '@angular/core';
import { Routes, RouterModule, RouteReuseStrategy } from '@angular/router';

import { CustomReuseStrategy } from './route-reuse-strategy';

import { PageResolver, RedirectGuard } from '@app/resolvers';

import {
  SearchComponent,
  VideoComponent,
  DetailComponent,
  HomeComponent,
  SchoolsComponent,
  SchoolComponent,
  DevelopComponent,
  NavigationComponent,
  AboutComponent,
} from '@app/pages';

const routes: Routes = [
  /**** HOME ****/

  {
    path: 'uvod',
    component: HomeComponent,
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    data: {
      section: 'uvod',
      sectionName: 'Úvod',
      index: 2,
      detail: false,
      virtualParent: true,
      reuseRoute: true,
      limit: 4
    },
    resolve: {
      routeResolver: PageResolver,
    },
    /*canActivate: [RedirectGuard],*/
  },

  /**** HLEDAT ****/
  {
    path: 'hledat',
    component: SearchComponent,
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    data: {
      section: 'hledat',
      sectionName: 'Hledat',
      index: 1,
      detail: false,
      reuseRoute: true,
      virtualParent: true,
      limit: 8
    },
    resolve: {
      routeResolver: PageResolver,
    },
    /*canActivate: [RedirectGuard],*/
  },
  {
    path: 'inspirace',
    data: {
      detail: true
    },

    children: [
      /**** VIDEA ****/
      {
        path: 'videa',
        component: VideoComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'inspirace',
          sectionName: 'Videa',
          index: 100,
          reuseRoute: true,
          detail: false,
          virtualParent: true,
          limit: 8
        },
        resolve: {
          routeResolver: PageResolver,
        },
        /*canActivate: [RedirectGuard],*/
        children: [],
      },

      /**** CLANKY ****/
      {
        path: 'clanky',
        component: VideoComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'inspirace',
          index: 200,
          sectionName: 'Články',
          detail: false,
          reuseRoute: true,
          virtualParent: true,
          limit: 8
        },
        resolve: {
          routeResolver: PageResolver,
        },
        /*canActivate: [RedirectGuard],*/
        children: [],
      },

      /**** FILMY ****/

      {
        path: 'filmy',
        component: VideoComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'inspirace',
          index: 300,
          sectionName: 'Filmy',
          detail: false,
          reuseRoute: true,
          virtualParent: true,
          limit: 8
        },
        resolve: {
          routeResolver: PageResolver,
        },
        /*canActivate: [RedirectGuard],*/
      },
      
      /**** INSPIRATIVNI SKOLY ****/

      {
        path: 'inspirativni-skoly',
        component: SchoolsComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'inspirace',
          index: 400,
          resetSchool: false,
          detail: false,
          virtualGrandParent: true,
          reuseRoute: true,
          limit: 8
        },
        resolve: {
          routeResolver: PageResolver,
        },
        /*canActivate: [RedirectGuard],*/
      },

      {
        path: 'inspirativni-skoly/:school',
        component: SchoolComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'inspirace',
          index: 410,
          //displayPage: true,
          virtualParent: true,
          //resetSchool: true,
          detail: false,
          reuseRoute: true,
          clearPager: true,
          limit: 8
        },
        resolve: {
          routeResolver: PageResolver,
        },
        /*canActivate: [RedirectGuard],*/
      },
      
      /**** INSPIRATIVNI LIDE ****/

      {
        path: 'inspirativni-lide',
        component: VideoComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'inspirace',
          index: 500,
          detail: false,
          reuseRoute: true,
          virtualParent: true,
          limit: 8
        },
        resolve: {
          routeResolver: PageResolver,
        },
        /*canActivate: [RedirectGuard],*/
      },

      /**** PARTNERI ****/

      {
        path: 'inspirativni-organizace',
        component: SchoolsComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'inspirace',
          index: 600,
          //resetSchool: false,
          detail: false,
          virtualGrandParent: true,
          reuseRoute: true,
          limit: 8
        },
        resolve: {
          routeResolver: PageResolver,
        },
        /*canActivate: [RedirectGuard],*/
      },

      {
        path: 'inspirativni-organizace/:school',
        component: SchoolComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'inspirace',
          index: 610,
          displayPage: true,
          virtualParent: true,
          detail: false,
          clearPager: true,
          reuseRoute: true,
          limit: 8
        },
        resolve: {
          routeResolver: PageResolver,
        },
        /*canActivate: [RedirectGuard],*/
      } 
    ],
  },
  {
    path: 'nastroje',
    data: {
      detail: true
    },


    children: [
      /*{
        path: 'webinar',
        component: DevelopComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'nastroje',
          index: 700,
          holdingPage: true
        },
        resolve: {
          routeResolver: PageResolver
        },
        canActivate: [RedirectGuard]
      },*/

      {
        path: 'kurzy',
        component: VideoComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'nastroje',
          index: 800,
          subPage: '/kurzy',
          detail: false,
          reuseRoute: true,
          virtualParent: true,
          limit: 8
        },
        resolve: {
          routeResolver: PageResolver,
        },
        /*canActivate: [RedirectGuard],*/
      },
      
      {
        path: 'materialy',
        component: VideoComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'nastroje',
          index: 900,
          detail: false,
          reuseRoute: true,
          virtualParent: true,
          limit: 8
        },
        resolve: {
          routeResolver: PageResolver,
        },
        /*canActivate: [RedirectGuard],*/
      }
    ],
  },
  {
    path: 'komunita',
    data: {
      detail: true
    },

    children: [
      {
        path: 'otazky-odpovedi',
        component: VideoComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'komunita',
          index: 1000,
          //resetSchool: false,
          detail: false,
          reuseRoute: true,
          virtualParent: true,
          limit: 8
        },
        resolve: {
          routeResolver: PageResolver,
        },
        /*canActivate: [RedirectGuard],*/
      },

      {
        path: 'pro-ukrajinu',
        component: VideoComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'komunita',
          index: 1200,
          //holdingPage: false,
          subPage: '/pro-ukrajinu',
          detail: false,
          reuseRoute: true,
          virtualParent: true,
          limit: 12
        },
        resolve: {
          routeResolver: PageResolver,
        },
        /*canActivate: [RedirectGuard],*/
      }

      /*,{
        path: 'blog',
        component: DevelopComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'komunita',
          index: 1300,
          holdingPage: true
        },
        resolve: {
          routeResolver: PageResolver
        },
        canActivate: [RedirectGuard]
      },*/

      /**** KOLEKTIVNI SNENI ****/

      /*{
        path: 'kolektivni-sneni',
        component: DevelopComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'komunita',
          index: 1400,
          holdingPage: true
        },
        resolve: {
          routeResolver: PageResolver
        },
        canActivate: [RedirectGuard]
      }*/
    ],
  },

  /* O NÁS */

  {
    path: 'o-nas',

    children: [
      {
        path: 'kontakt',
        component: AboutComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'o-nas',
          index: 20000,
          simplePage: true,
          detail: false
        },
        resolve: {
          routeResolver: PageResolver,
        },
        /*canActivate: [RedirectGuard],*/
      },

      {
        path: 'tym',
        component: AboutComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'o-nas',
          index: 21000,
          simplePage: true,
          detail: false
        },
        resolve: {
          routeResolver: PageResolver,
        },
        /*canActivate: [RedirectGuard],*/
      },

      /*{
        path: 'podporte-nas',
        component: AboutComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        data: {
          section: 'o-nas',
          index: 22000,
          simplePage: true,
          detail: false
        },
        resolve: {
          routeResolver: PageResolver,
        },
        canActivate: [RedirectGuard],
      },*/
    ],
  },


  

  /* NAVIGATION */

  {
    path: 'navigace',
    component: NavigationComponent,
    data: {
      section: 'navigation',
      index: 0,
      simplePage: true,
      detail: false
    },
    resolve: {
      routeResolver: PageResolver,
    },
  },

  /* DETAIL */

  {
    path: ':id',
    component: DetailComponent,
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    data: {
      index: 2000,
      detail: true,
      reuseRoute: false,
      limit: 8
    },
    resolve: {
      routeResolver: PageResolver,
    }/*,
    canActivate: [RedirectGuard],*/
  },

  /* USER */

  {
    path: 'uzivatel',
    loadChildren: async () => (await import('@app/user')).UserModule,
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    data: {
      index: 30000,
      section: 'user',
      detail: false,
      simplePage: true,
      reuseRoute: false
    },
    resolve: {
      routeResolver: PageResolver,
    }
  },

  {
    path: 'pro-ukrajinu',
    pathMatch: 'full',
    redirectTo: '/komunita/pro-ukrajinu',
  },

  { path: '', pathMatch: 'full', redirectTo: '/uvod' },
  { path: '**', pathMatch: 'full', redirectTo: '/uvod' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      onSameUrlNavigation: 'ignore',
      scrollPositionRestoration: 'disabled',
      enableTracing: false
    }),
  ],
  exports: [RouterModule],
  providers: [
    PageResolver,
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy }
  ],
})
export class AppRoutingModule {}
